import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { isNumber } from 'lodash';
import { ThemeModeContext } from '@luigiclaudio/ga-baseline-ui/theme-provider';
import ColorVarianStepBarContainer from './ColorVarianStepBarContainer';
import ColorVarianStepBarValue from './ColorVarianStepBarValue';
import ColorVarianStepBarDivider from './ColorVarianStepBarDivider';

const ColorVarianStepBar = ({ value, stepValue, stepLabel, widthValue, hasChanged }) => {
    const { themeMode } = useContext(ThemeModeContext);

    if (!isNumber(stepValue)) {
        return null;
    }

    return (
        <ColorVarianStepBarContainer
            stepValue={stepValue}
            widthValue={widthValue}
            hasChanged={hasChanged}
        >
            <ColorVarianStepBarValue stepValue={stepValue} themeMode={themeMode}>
                {stepLabel || value}
            </ColorVarianStepBarValue>
            <ColorVarianStepBarDivider themeMode={themeMode} />
        </ColorVarianStepBarContainer>
    );
};

ColorVarianStepBar.propTypes = {
    value: PropTypes.number,
    stepValue: PropTypes.number,
    widthValue: PropTypes.number,
    hasChanged: PropTypes.bool,
    stepLabel: PropTypes.string,
};

ColorVarianStepBar.defaultProps = {
    value: undefined,
    stepValue: undefined,
    widthValue: undefined,
    hasChanged: false,
    stepLabel: undefined,
};

export default ColorVarianStepBar;
